import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { PercievedProvisioningTiming } from '@/components/signup/provisioning-funnel-ufo/provisioning-funnel-ufo';
import { UfoCustomTimingKey } from '@/components/signup/utils/ufo.types';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { useCloudStatus } from '../../../../hooks/use-cloud-status';
import { ANALYTICS_PREFIX } from '../../common/constants';
import { PageBoardColumnsProps } from '../../common/types';
import { LeftHandSideWrapper } from '../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper';
import { RightHandSideWrapper } from '../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper';
import { useWizardConfiguration } from '../../controllers';

import { LeftHandSidePageBoardColumns } from './left-hand-side/left-hand-side';
import { RightHandSidePageBoardColumns } from './right-hand-side/right-hand-side';

export const PageBoardColumns = ({
	projectName,
	onClickNext,
	columnNames,
	setColumnNames,
	isBoardColumnsSubmitting,
}: PageBoardColumnsProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { createCloudStatus } = useCloudStatus();

	const {
		teamType,
		projectDetails: { template },
	} = useWizardConfiguration();

	useEffect(() => {
		createAnalyticsEvent({
			action: 'viewed',
			eventType: 'screen',
			name: `${ANALYTICS_PREFIX}BoardColumns`,
			attributes: {
				teamType,
				template,
			},
		}).fire();
	}, [createAnalyticsEvent, teamType, template]);

	return (
		<>
			{
				// measure provisioning
				checkFeatureFlagGate(featureFlags.provisioningFunnelUfoImprovements) &&
					isBoardColumnsSubmitting &&
					createCloudStatus !== 'success' && (
						<PercievedProvisioningTiming
							provisioningFunnelTimingKey={
								UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS
							}
						/>
					)
			}

			{
				// measure project creation initialized
				checkFeatureFlagGate(featureFlags.provisioningFunnelUfoImprovements) &&
					isBoardColumnsSubmitting &&
					createCloudStatus === 'success' && (
						<PercievedProvisioningTiming
							provisioningFunnelTimingKey={
								UfoCustomTimingKey.PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED
							}
						/>
					)
			}
			<LeftHandSideWrapper>
				<LeftHandSidePageBoardColumns
					onClickNext={onClickNext}
					columnNames={columnNames}
					setColumnNames={setColumnNames}
					isBoardColumnsSubmitting={isBoardColumnsSubmitting}
				/>
			</LeftHandSideWrapper>
			<RightHandSideWrapper>
				<RightHandSidePageBoardColumns projectName={projectName} columnNames={columnNames} />
			</RightHandSideWrapper>
		</>
	);
};
